import styled from 'styled-components'
import { Link } from 'react-router-dom'

/**
 * The purpose of this componer is to have a linke that inherits all styling,
 * avoiding the default styled for `a` tag.
 * So, if you are going to remove any css styling by default on this, feel free to do it
 */
export default styled(Link)`
    color: inherit;
    text-decoration: inherit;
`
